import { SkeletonHeadline } from '@xing-com/skeleton';

export type CommentListSkeletonProps = {
  className?: string;
};

export const CommentListSkeleton: React.FC<CommentListSkeletonProps> = ({
  className,
}) => {
  return (
    <SkeletonHeadline
      alignment="left"
      amountRows={1}
      size="small"
      className={className}
      data-qa="social-comment-list-skeleton"
    />
  );
};
